module.exports = __webpack_public_path__ + "img/slide-imageview_active.68aa2db0.svg";